// @flow
import * as React from 'react';
import { graphql } from 'react-apollo';
import idx from 'idx';

import OrganizationAnnouncementsPage from 'organizations/components/OrganizationAnnouncementsPage';
import LoadingIndicator from 'components/LoadingIndicator';
import Redirect from 'components/Redirect';
import GroupViewQueryParametersConsumer from 'groups/components/GroupViewQueryParametersConsumer';
import ORGANIZATION_ANNOUNCEMENTS_CONTAINER_QUERY from 'organizations/queries/OrganizationAnnouncementsContainerQuery.gql';
import type { OrganizationAnnouncementsContainerVariables } from 'organizations/queries/__generated__/OrganizationAnnouncementsContainer';

type Props = {
  data: *,
  params: { id: string },
};

class OrganizationAnnouncementsContainer extends React.Component<Props, *> {
  render() {
    const { data } = this.props;
    if (data.loading) {
      return (
        <div className="OrganizationAnnouncementsPage OrganizationAnnouncementsPage--centered">
          <LoadingIndicator />
        </div>
      );
    }
    const organization = data.organizations ? data.organizations[0] : null;
    if (organization) {
      const section = organization.streamSections.find(s => s.type === 'chats');
      const streams = idx(section, _ => _.streams);
      const orgAnnouncementStream = streams
        ? streams.find(stream => stream.__typename === 'EntityStream')
        : null;

      return (
        <React.Fragment>
          <GroupViewQueryParametersConsumer />
          <OrganizationAnnouncementsPage
            organization={organization}
            streamUuid={orgAnnouncementStream ? orgAnnouncementStream.uuid : null}
          />
        </React.Fragment>
      );
    }
    console.error('OrganizationAnnouncementsContainer - loaded without an organization');
    console.warn(data.error);
    return <Redirect to="/classes" />;
  }
}

const withOrganization = graphql(ORGANIZATION_ANNOUNCEMENTS_CONTAINER_QUERY, {
  options: ({ params }: Props): { variables: OrganizationAnnouncementsContainerVariables } => ({
    variables: { organizationId: Number(params.id) },
  }),
});

export { OrganizationAnnouncementsContainer };
export default withOrganization(OrganizationAnnouncementsContainer);
